import { Database } from "@punchup/data/supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";
import { createSupabaseAdminClient } from "../supabase/supabase";
import { logException } from "@punchup/sentry";

export type Product = Database["public"]["Tables"]["products"]["Row"];

export async function getProductByID(id: string): Promise<Product | null> {
  const supabase = createSupabaseAdminClient();
  const { data, error } = await supabase
    .from("products")
    .select("*")
    .eq("id", id)
    .maybeSingle();

  if (error) {
    logException(error);
    throw error;
  }

  return data;
}

export async function getProductsForSpecial(
  supabase: SupabaseClient<Database>,
  specialId: string
): Promise<Product[]> {
  const { data, error } = await supabase
    .from("product_specials")
    .select("products(*)")
    .eq("special_id", specialId);

  if (error) {
    logException(error);
    throw error;
  }

  return (
    data
      .map((item) => item.products)
      .filter((item): item is Product => item != null) ?? null
  );
}
